<template>
  <div class="dashboard-bottom bg-light p-2" style="position:relative">
    <div class="pointer" style="position:absolute;right:1%" @click="downloadReport()">
      <i class="fa-solid fa-file-arrow-down" style="color:red"></i>
    </div>
    <chart :chartData="chartData" :options="chartOptions" :styles="{ height: '100%', width: '100%' }"
      v-if="tkdnCategories" />
  </div>
</template>
<script>
import moment from 'moment'
import numeral from 'numeral'
import * as XLSX from 'sheetjs-style'
import axios from 'axios'
import { api } from '@/services/config'
export default {
  components: {
    chart: () => import('@/components/chart/dashboard/bar-chart.vue'),
  },
  data() {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Domestik (USD)',
            backgroundColor: 'pink',
            data: [],
            yAxisID: 'A',
            order: 2,
          },
          {
            label: 'Impor (USD)',
            backgroundColor: 'orange',
            data: [],
            yAxisID: 'A',
            order: 3,
          },
          {
            label: 'Belanja TKDN (USD)',
            backgroundColor: 'red',
            borderColor: 'red',
            fill: false,
            lineTension: 0,
            data: [],
            type: 'line',
            yAxisID: 'B',
            order: 1,
          },
        ],
      },
      chartOptions: {
        showDatapoints: true,
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Realisasi TKDN Kategori ESDM',
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        tooltips: {
          mode: 'index',
          axis: 'y',
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || ''

              if (label) {
                label += ': '
              }
              // label += Math.round(tooltipItem.yLabel * 100) / 100;
              let idr = numeral(tooltipItem.yLabel).format('0,0.00')
              let newIdr = ''
              idr.split('').map(list => {
                if (list == ',') {
                  newIdr += '.'
                } else if (list == '.') {
                  newIdr += ','
                } else {
                  newIdr += list
                }
              })

              label += newIdr
              return label
            },
          },
        },
        scales: {
          yAxes: [
            {
              id: 'A',
              position: 'left',
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'NILAI BELANJA TKDN',
              },
            },
            {
              id: 'B',
              position: 'right',
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'NILAI PENGADAAN',
              },
              grid: {
                drawOnChartArea: false, // only want the grid lines for one axis to show up
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'KATEGORI ESDM',
              },
            },
          ],
        },
      },
    }
  },
  computed: {
    tkdnCategories() {
      let data = this.$store.state.tkdnStore.tkdnCategories
      this.convertData(data)

      return true
    },
  },
  methods: {
    async downloadTkdn() {
      try {
        const start = this.$store.state.tkdnStore.start
        const end = this.$store.state.tkdnStore.end
        const code = this.$store.state.tkdnStore.code
        const server = this.$store.state.tkdnStore.server

        let serverChoosed = ''

        if (server) {
          serverChoosed = `&server=${server}`
        }

        await this.startDownload()
        let url = `${api}/api/v1/po/download-report?table=${this.$store.state.tkdnStore.table}${serverChoosed}`

        if (start && end) {
          url += `&end=${end}&start=${start}&company=${code}`
        }

        const { data } = await axios({
          url,
          method: 'GET',
        })

        if (data && data.status == 'success') {
          this.finishDownload()
          return data.data
        }
      } catch (error) {
        this.finishDownload()
      }
    },
    convertData(data) {
      if (data && data.length > 0) {
        let categories = {}
        data.forEach(item => {
          if (categories[`${item['ESDM_CATEGORY_DESC']}`] == undefined) {
            categories[`${item['ESDM_CATEGORY_DESC']}`] = {
              domestik: {
                value:
                  item['REG'] == 'domestik'
                    ? Number(item['TOTAL_VALUE_USD'])
                    : 0,
              },
              impor: {
                value:
                  item['REG'] == 'import' ? Number(item['TOTAL_VALUE_USD']) : 0,
              },
              tkdn: {
                value: Number(item['TOTAL_TKDN']),
              },
            }
          } else {
            categories[`${item['ESDM_CATEGORY_DESC']}`]['domestik']['value'] +=
              item['REG'] == 'domestik' ? Number(item['TOTAL_VALUE_USD']) : 0
            categories[`${item['ESDM_CATEGORY_DESC']}`]['impor']['value'] +=
              item['REG'] == 'import' ? Number(item['TOTAL_VALUE_USD']) : 0
            categories[`${item['ESDM_CATEGORY_DESC']}`]['tkdn'][
              'value'
            ] += Number(item['TOTAL_TKDN'])
          }
        })

        let labels = Object.keys(categories)
        let arrLabel = []
        let domestik = []
        let impor = []
        let tkdn = []

        for (let i in labels) {
          arrLabel.push(labels[i])
          domestik.push(categories[labels[i]]['domestik']['value'])
          impor.push(categories[labels[i]]['impor']['value'])
          tkdn.push(categories[labels[i]]['tkdn']['value'])
        }

        this.chartData = {
          labels: arrLabel,
          datasets: [
            {
              label: 'Belanja TKDN (USD)',
              backgroundColor: 'pink',
              data: tkdn,
              yAxisID: 'A',
              order: 2,
            },
            {
              label: 'Impor (USD)',
              backgroundColor: 'orange',
              data: impor,
              yAxisID: 'A',
              order: 3,
            },
            {
              label: 'Domestik (USD)',
              backgroundColor: 'red',
              borderColor: 'red',
              fill: false,
              lineTension: 0,
              data: domestik,
              type: 'line',
              yAxisID: 'B',
              order: 1,
            },
          ],
        }
      } else {
        this.chartData = {
          labels: [],
          datasets: [
            {
              label: 'Belanja TKDN (USD)',
              backgroundColor: 'pink',
              data: [],
              yAxisID: 'A',
              order: 2,
            },
            {
              label: 'Impor (USD)',
              backgroundColor: 'orange',
              data: [],
              yAxisID: 'A',
              order: 3,
            },
            {
              label: 'Domestik (USD)',
              backgroundColor: 'red',
              borderColor: 'red',
              fill: false,
              lineTension: 0,
              data: [],
              type: 'line',
              yAxisID: 'B',
              order: 1,
            },
          ],
        }
      }
    },
    startDownload() {
      this.$store.commit('SET_GLOBAL_LOADING', true)
    },
    finishDownload() {
      this.$store.commit('SET_GLOBAL_LOADING', false)
    },
    async downloadReport() {
      try {
        let start = this.$store.state.tkdnStore.start
        let end = this.$store.state.tkdnStore.end

        if (!start && !end) {
          start = moment()
            .add(-2, 'years')
            .format('YYYY-MM-DD')
          end = moment().format('YYYY-MM-DD')
        }

        let dataPo = await this.downloadTkdn()

        if (dataPo && dataPo.length > 0) {
          let categories = []
          let cat_temp = []

          dataPo.forEach(item => {
            if (categories[`${item['ESDM_CATEGORY']}`] == undefined) {
              categories[`${item['ESDM_CATEGORY']}`] = [
                {
                  Kategori: item['ESDM_CATEGORY'].toUpperCase(),
                  'Jenis Barang': item['ITEM_TEXT'],
                  Nasional:
                    this.$get(item, 'vendor.negara_id') == '63'
                      ? 'Nasional'
                      : 'International',
                  Provinsi: this.$get(item, 'vendor.provinsi.desc', ''),
                  Kabupaten: this.$get(item, 'vendor.kota.desc', ''),
                  Negara: this.$get(item, 'vendor.negara.negara', ''),
                  'Produsen/Supplier': item['VENDOR_NAME'],
                  Spesifikasi: item['ITEM_TEXT'],
                  Kuantitas: '',
                  'Cost, Insurance, &Freight': '',
                  'On Site': '',
                  'Total Price (USD)': parseFloat(
                    Number(item['TOTAL_VALUE_USD']).toFixed(2)
                  ),
                  'Total Price (IDR)': parseFloat(
                    Number(item['TOTAL_VALUE_IDR']).toFixed(2)
                  ),
                  'Area Project': '',
                  total_domestik:
                    item['REG'] == 'domestik'
                      ? parseFloat(Number(item['TOTAL_VALUE_USD']).toFixed(2))
                      : 0,
                  total_import:
                    item['REG'] == 'import'
                      ? parseFloat(Number(item['TOTAL_VALUE_IDR']).toFixed(2))
                      : 0,
                  'Presentase TKDN (%)': parseFloat(
                    Number(item['TKDN']).toFixed(2)
                  ),
                  'Bobot (%)': '',
                  'Belanja TKDN (IDR)': parseFloat(
                    (
                      (Number(item['TOTAL_VALUE_USD']) * Number(item['TKDN'])) /
                      100
                    ).toFixed(2)
                  ),
                  'TKDN KATEGORI': '',
                },
              ]
            } else {
              categories[`${item['ESDM_CATEGORY']}`].push({
                Kategori: item['ESDM_CATEGORY'].toUpperCase(),
                'Jenis Barang': item['ITEM_TEXT'],
                Nasional:
                  this.$get(item, 'vendor.negara_id') == '63'
                    ? 'Nasional'
                    : 'International',
                Provinsi: this.$get(item, 'vendor.provinsi.desc', ''),
                Kabupaten: this.$get(item, 'vendor.kota.desc', ''),
                Negara: this.$get(item, 'vendor.negara.negara', ''),
                'Produsen/Supplier': item['VENDOR_NAME'],
                Spesifikasi: item['ITEM_TEXT'],
                Kuantitas: '',
                'Cost, Insurance, &Freight': '',
                'On Site': '',
                total_domestik:
                  item['REG'] == 'domestik'
                    ? parseFloat(Number(item['TOTAL_VALUE_USD']).toFixed(2))
                    : 0,
                total_import:
                  item['REG'] == 'import'
                    ? parseFloat(Number(item['TOTAL_VALUE_USD']).toFixed(2))
                    : 0,
                'Total Price (USD)': parseFloat(
                  Number(item['TOTAL_VALUE_USD']).toFixed(2)
                ),
                'Total Price (IDR)': parseFloat(
                  Number(item['TOTAL_VALUE_IDR']).toFixed(2)
                ),
                'Area Project': '',
                'Presentase TKDN (%)': parseFloat(
                  Number(item['TKDN']).toFixed(2)
                ),
                'Bobot (%)': '',
                'Belanja TKDN (IDR)': parseFloat(
                  (
                    (Number(item['TOTAL_VALUE_USD']) * Number(item['TKDN'])) /
                    100
                  ).toFixed(2)
                ),
                'TKDN KATEGORI': '',
              })
            }
          })

          dataPo.forEach(item => {
            if (cat_temp[`${item['ESDM_CATEGORY']}`] == undefined) {
              cat_temp[`${item['ESDM_CATEGORY']}`] = [
                {
                  Kategori: item['ESDM_CATEGORY'].toUpperCase(),
                  'Jenis Barang': item['ITEM_TEXT'],
                  Nasional:
                    this.$get(item, 'vendor.negara_id') == '63'
                      ? 'Nasional'
                      : 'International',
                  Provinsi: this.$get(item, 'vendor.provinsi.desc', ''),
                  Kabupaten: this.$get(item, 'vendor.kota.desc', ''),
                  Negara: this.$get(item, 'vendor.negara.negara', ''),
                  'Produsen/Supplier': item['VENDOR_NAME'],
                  Spesifikasi: item['ITEM_TEXT'],
                  Kuantitas: '',
                  'Cost, Insurance, &Freight': '',
                  'On Site': '',
                  total_domestik:
                    item['REG'] == 'domestik'
                      ? parseFloat(Number(item['TOTAL_VALUE_USD']).toFixed(2))
                      : 0,
                  total_import:
                    item['REG'] == 'import'
                      ? parseFloat(Number(item['TOTAL_VALUE_USD']).toFixed(2))
                      : 0,
                  'Total Price (USD)': parseFloat(
                    Number(item['TOTAL_VALUE_USD']).toFixed(2)
                  ),
                  'Total Price (IDR)': parseFloat(
                    Number(item['TOTAL_VALUE_IDR']).toFixed(2)
                  ),
                  'Area Project': '',
                  'Presentase TKDN (%)': parseFloat(
                    Number(item['TKDN']).toFixed(2)
                  ),
                  'Bobot (%)': '',
                  'Belanja TKDN (IDR)': parseFloat(
                    (
                      (Number(item['TOTAL_VALUE_USD']) * Number(item['TKDN'])) /
                      100
                    ).toFixed(2)
                  ),
                  'TKDN KATEGORI': '',

                },
              ]
            } else {
              cat_temp[`${item['ESDM_CATEGORY']}`].push({
                Kategori: item['ESDM_CATEGORY'].toUpperCase(),
                'Jenis Barang': item['ITEM_TEXT'],
                Nasional:
                  this.$get(item, 'vendor.negara_id') == '63'
                    ? 'Nasional'
                    : 'International',
                Provinsi: this.$get(item, 'vendor.provinsi.desc', ''),
                Kabupaten: this.$get(item, 'vendor.kota.desc', ''),
                Negara: this.$get(item, 'vendor.negara.negara', ''),
                'Produsen/Supplier': item['VENDOR_NAME'],
                Spesifikasi: item['ITEM_TEXT'],
                Kuantitas: '',
                'Cost, Insurance, &Freight': '',
                'On Site': '',
                total_domestik:
                  item['REG'] == 'domestik'
                    ? parseFloat(Number(item['TOTAL_VALUE_USD']).toFixed(2))
                    : 0,
                total_import:
                  item['REG'] == 'import'
                    ? parseFloat(Number(item['TOTAL_VALUE_USD']).toFixed(2))
                    : 0,
                'Total Price (USD)': parseFloat(
                  Number(item['TOTAL_VALUE_USD']).toFixed(2)
                ),
                'Total Price (IDR)': parseFloat(
                  Number(item['TOTAL_VALUE_IDR']).toFixed(2)
                ),
                'Area Project': '',
                'Presentase TKDN (%)': parseFloat(
                  Number(item['TKDN']).toFixed(2)
                ),
                'Bobot (%)': '',
                'Belanja TKDN (IDR)': parseFloat(
                  (
                    (Number(item['TOTAL_VALUE_USD']) * Number(item['TKDN'])) /
                    100
                  ).toFixed(2)
                ),
                'TKDN KATEGORI': '',

              })
            }
          })

          const data = Object.keys(cat_temp)
          let total_price = {}
          // let total_price_idr = {}
          let total_belanja = {}
          let tkdn_category = {}

          data.forEach(list => {
            let temp_total_price = cat_temp[list].reduce(function (acc, obj) {
              return (
                parseFloat(acc) + parseFloat(obj['Total Price (USD)'])
              ).toFixed(2)
            }, 0)

            let temp_total_price_idr = cat_temp[list].reduce(function (acc, obj) {
              return (
                parseFloat(acc) + parseFloat(obj['Total Price (IDR)'])
              ).toFixed(2)
            }, 0)

            let temp_total_belanja = cat_temp[list].reduce(function (acc, obj) {
              return (
                parseFloat(acc) + parseFloat(obj['Belanja TKDN (IDR)'])
              ).toFixed(2)
            }, 0)

            let temp_total_domestik = cat_temp[list].reduce(function (acc, obj) {
              return (
                parseFloat(acc) + parseFloat(obj['total_domestik'])
              ).toFixed(2)
            }, 0)

            let temp_total_import = cat_temp[list].reduce(function (acc, obj) {
              return (
                parseFloat(acc) + parseFloat(obj['total_import'])
              ).toFixed(2)
            }, 0)

            total_price[list.toUpperCase()] = {
              all: temp_total_price,
              idr: temp_total_price_idr,
              dom: temp_total_domestik,
              imp: temp_total_import,
            }
            total_belanja[list.toUpperCase()] = temp_total_belanja
            tkdn_category[list.toUpperCase()] =
              Number(temp_total_belanja) / Number(temp_total_price)
          })

          for (let i in categories) {
            for (let j in categories[i]) {
              categories[i][j]['Bobot (%)'] = parseFloat(
                (
                  (Number(categories[i][j]['Total Price (USD)']) /
                    Number(total_price[categories[i][j]['Kategori']]['all'])) *
                  Number(categories[i][j]['Presentase TKDN (%)'])
                ).toFixed(2)
              )
              categories[i][j]['TKDN KATEGORI'] = parseFloat(
                Number(tkdn_category[categories[i][j]['Kategori']].toFixed(2))
              )
            }
          }

          const shortData = data.sort()

          let wb = XLSX.utils.book_new()
          data.forEach(list => {
            let initialPo = [
              {
                Kategori: '',
                'Jenis Barang': '',
                Nasional: '',
                Provinsi: '',
                Kabupaten: '',
                Negara: '',
                'Produsen/Supplier': '',
                Spesifikasi: '',
                Kuantitas: '',
                'Cost, Insurance, &Freight': '',
                'On Site': '',
                'total_domestik': '',
                'total_import': '',
                'Total Price (USD)': '',
                'Total Price (IDR)': '',
                'Area Project': '',
                'Presentase TKDN (%)': '',
                'Bobot (%)': '',
                'Belanja TKDN (IDR)': '',
                'TKDN KATEGORI': '',
              },
              ...categories[list],
              {
                Kategori: '',
                'Jenis Barang': '',
                Nasional: '',
                Provinsi: '',
                Kabupaten: '',
                Negara: '',
                'Produsen/Supplier': '',
                Spesifikasi: `Sub Total Kategori ${categories[list][0]['Kategori']}`,
                Kuantitas: '',
                'Cost, Insurance, &Freight': '',
                'On Site': '',
                'total_domestik': parseFloat(
                  Number(
                    total_price[categories[list][0]['Kategori']]['dom']
                  ).toFixed(2)
                ),
                'total_import': parseFloat(
                  Number(
                    total_price[categories[list][0]['Kategori']]['imp']
                  ).toFixed(2)
                ),
                'Total Price (USD)': parseFloat(
                  Number(
                    total_price[categories[list][0]['Kategori']]['all']
                  ).toFixed(2)
                ),
                'Total Price (IDR)': parseFloat(
                  Number(
                    total_price[categories[list][0]['Kategori']]['idr']
                  ).toFixed(2)
                ),
                'Area Project': '',
                'Presentase TKDN (%)': '',
                'Bobot (%)': '',
                'Belanja TKDN (IDR)': parseFloat(
                  Number(
                    total_belanja[categories[list][0]['Kategori']]
                  ).toFixed(2)
                ),
                'TKDN KATEGORI': '',
              },
            ]
            let totalInitialPO = Number(initialPo.length) - 1
            for (let i in initialPo) {
              if (i == totalInitialPO) {
                initialPo[i]['total_domestik'] = this.curencyDelimiter(
                  Number(initialPo[i]['total_domestik'])
                )
                initialPo[i]['total_import'] = this.curencyDelimiter(
                  Number(initialPo[i]['total_import'])
                )
                initialPo[i]['Total Price (USD)'] = this.curencyDelimiter(
                  Number(initialPo[i]['Total Price (USD)'])
                )
                initialPo[i]['Total Price (IDR)'] = this.curencyDelimiter(
                  Number(initialPo[i]['Total Price (IDR)'])
                )
                initialPo[i]['Belanja TKDN (IDR)'] = this.curencyDelimiter(
                  Number(initialPo[i]['Belanja TKDN (IDR)'])
                )
              } else {
                initialPo[i]['total_domestik'] = this.curencyDelimiter(
                  Number(initialPo[i]['total_domestik'])
                )
                initialPo[i]['total_import'] = this.curencyDelimiter(
                  Number(initialPo[i]['total_import'])
                )
                initialPo[i]['Total Price (USD)'] = this.curencyDelimiter(
                  Number(initialPo[i]['Total Price (USD)'])
                )
                initialPo[i]['Total Price (IDR)'] = this.curencyDelimiter(
                  Number(initialPo[i]['Total Price (IDR)'])
                )
                initialPo[i]['Presentase TKDN (%)'] = `${initialPo[i]['Presentase TKDN (%)']}%`;
                initialPo[i]['Bobot (%)'] = `${initialPo[i]['Bobot (%)']}%`;
                // initialPo[i]['Presentase TKDN (%)'] = this.curencyDelimiter(
                //   Number(initialPo[i]['Presentase TKDN (%)'])
                // )
                // initialPo[i]['Bobot (%)'] = this.curencyDelimiter(
                //   Number(initialPo[i]['Bobot (%)'])
                // )
                initialPo[i]['Belanja TKDN (IDR)'] = this.curencyDelimiter(
                  Number(initialPo[i]['Belanja TKDN (IDR)'])
                )
                // initialPo[i]['TKDN KATEGORI'] = this.curencyDelimiter(
                //   Number(initialPo[i]['TKDN KATEGORI'])
                // )
                initialPo[i]['TKDN KATEGORI'] = `${initialPo[i]['TKDN KATEGORI']}%`;
              }
            }
            let po = XLSX.utils.json_to_sheet(initialPo)
            // A workbook is the name given to an Excel file

            // add Worksheet to Workbook
            // Workbook contains one or more worksheets
            XLSX.utils.book_append_sheet(wb, po, list.toUpperCase()) // sheetAName is name of Worksheet
            // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')
            // export Excel file

            const header = [
              [
                'Kategori',
                'Jenis Barang',
                'Asal',
                '',
                '',
                '',
                'Produsen/Supplier',
                'Spesifikasi',
                'Kuantitas',
                'Unit Price (USD)',
                '',
                'Domestik (USD)',
                'Import (USD)',
                'Total Price (USD)',
                'Total Price (IDR)',
                'Area Project',
                'Presentase TKDN (%)',
                'Bobot (%)',
                'Belanja TKDN (USD)',
                `Presentasi TKDN Kategori ${list.toUpperCase()}(%)`,
              ],
              [
                '',
                '',
                'Nasional',
                'Provinsi',
                'Kabupaten',
                'Negara',
                '',
                '',
                '',
                'Cost, Insurance, &Freight',
                'On Site',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
              ],
            ]

            XLSX.utils.sheet_add_aoa(po, header, {
              origin: 'A1',
            })

            const merge = [
              { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
              { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },

              { s: { r: 0, c: 6 }, e: { r: 1, c: 6 } },
              { s: { r: 0, c: 7 }, e: { r: 1, c: 7 } },
              { s: { r: 0, c: 8 }, e: { r: 1, c: 8 } },

              { s: { r: 0, c: 11 }, e: { r: 1, c: 11 } },
              { s: { r: 0, c: 12 }, e: { r: 1, c: 12 } },
              { s: { r: 0, c: 13 }, e: { r: 1, c: 13 } },
              { s: { r: 0, c: 14 }, e: { r: 1, c: 14 } },
              { s: { r: 0, c: 15 }, e: { r: 1, c: 15 } },
              { s: { r: 0, c: 16 }, e: { r: 1, c: 16 } },
              { s: { r: 0, c: 17 }, e: { r: 1, c: 17 } },
              { s: { r: 0, c: 18 }, e: { r: 1, c: 18 } },
              { s: { r: 0, c: 19 }, e: { r: 1, c: 19 } },

              { s: { r: 0, c: 2 }, e: { r: 0, c: 5 } },
              { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } },
            ]

            po['!merges'] = merge

            const dateBox = {
              alignment: {
                vertical: 'left',
                horizontal: 'center',
              },
              border: {
                top: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                bottom: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                left: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                right: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
              },
            }

            const grayBox = {
              alignment: {
                vertical: 'center',
                horizontal: 'center',
              },
              fill: { fgColor: { rgb: 'D9D9D9' } },
              border: {
                top: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                bottom: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                left: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                right: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
              },
            }

            const borderBox = {
              border: {
                top: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                bottom: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                left: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                right: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
              },
            }

            const subBorderBox = {
              fill: { fgColor: { rgb: 'D6E3BC' } },
              border: {
                top: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                bottom: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                left: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                right: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
              },
            }

            const borderBoxRight = {
              alignment: {
                horizontal: 'right',
              },
              border: {
                top: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                bottom: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                left: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                right: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
              },
            }

            const subBorderBoxRight = {
              alignment: {
                horizontal: 'right',
              },
              fill: { fgColor: { rgb: 'D6E3BC' } },
              border: {
                top: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                bottom: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                left: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                right: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
              },
            }

            const fillStyle = {
              alignment: {
                vertical: 'center',
                horizontal: 'center',
              },
              fill: { fgColor: { rgb: '00B0F0' } },
              border: {
                top: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                bottom: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                left: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
                right: {
                  style: 'thin',
                  color: { rgb: '000000' },
                },
              },
            }

            let huruf = [
              'A',
              'B',
              'C',
              'D',
              'E',
              'F',
              'G',
              'H',
              'I',
              'J',
              'K',
              'L',
              'M',
              'N',
              'O',
              'P',
              'Q',
              'R',
              'S',
              'T',
            ]

            for (let i in categories[list]) {
              let a = Number(i) + 3
              for (let j in huruf) {
                if (j > 10) {
                  if (po[`${huruf[j]}${a}`]) {
                    po[`${huruf[j]}${a}`].s = borderBoxRight
                  }
                } else {
                  if (po[`${huruf[j]}${a}`]) {
                    po[`${huruf[j]}${a}`].s = borderBox
                  }
                }
              }
            }

            for (let j in huruf) {
              let a = Number(categories[list].length) + 3
              if (j > 10) {
                if (po[`${huruf[j]}${a}`]) {
                  po[`${huruf[j]}${a}`].s = borderBoxRight
                }
              } else {
                if (po[`${huruf[j]}${a}`]) {
                  po[`${huruf[j]}${a}`].s = borderBox
                }
              }

              if (huruf[j] == 'H') {
                if (po[`${huruf[j]}${a}`]) {
                  po[`${huruf[j]}${a}`].s = subBorderBox
                }
              }
              if (huruf[j] == 'L' || huruf[j] == 'M' || huruf[j] == 'N' || huruf[j] == 'O' || huruf[j] == 'S') {
                if (po[`${huruf[j]}${a}`]) {
                  po[`${huruf[j]}${a}`].s = subBorderBoxRight
                }
              }
            }

            po['A1'].s = grayBox
            po['B1'].s = grayBox
            po['A2'].s = grayBox
            po['B2'].s = grayBox

            po['G1'].s = grayBox
            po['H1'].s = grayBox
            po['I1'].s = grayBox

            po['L1'].s = grayBox
            po['M1'].s = grayBox
            po['N1'].s = grayBox
            po['O1'].s = grayBox
            po['P1'].s = grayBox
            po['Q1'].s = grayBox
            po['R1'].s = grayBox
            po['S1'].s = grayBox
            po['T1'].s = grayBox

            po['G2'].s = grayBox
            po['H2'].s = grayBox
            po['I2'].s = grayBox

            po['L2'].s = grayBox
            po['M2'].s = grayBox
            po['N2'].s = grayBox
            po['O2'].s = grayBox
            po['P2'].s = grayBox
            po['Q2'].s = grayBox
            po['R2'].s = grayBox
            po['S2'].s = grayBox
            po['T2'].s = grayBox

            po['C1'].s = fillStyle
            po['C2'].s = fillStyle
            po['D2'].s = fillStyle
            po['E2'].s = fillStyle
            po['F2'].s = fillStyle

            po['J1'].s = grayBox
            po['J2'].s = grayBox
            po['K2'].s = grayBox

            let wscols = [
              { wch: 10 },
              { wch: 25 },
              { wch: 15 },
              { wch: 15 },
              { wch: 15 },
              { wch: 15 },
              { wch: 25 },
              { wch: 25 },
              { wch: 10 },
              { wch: 25 },
              { wch: 15 },
              { wch: 20 },
              { wch: 15 },
              { wch: 20 },
              { wch: 20 },
              { wch: 20 },
              { wch: 30 },
              { wch: 30 },
              { wch: 30 },
              { wch: 30 },
            ]
            po['!cols'] = wscols
          })

          let reportData = [
            {
              categories: '',
              cat_desc: '',
              rencana_dom: '',
              rencana_imp: '',
              rencana_tkdn: '',
              realisasi_dom: 0,
              realisasi_imp: '',
              realisasi_tkdn: 0,
            },
            {
              categories: '',
              cat_desc: '',
              rencana_dom: '',
              rencana_imp: '',
              rencana_tkdn: '',
              realisasi_dom: 0,
              realisasi_imp: '',
              realisasi_tkdn: 0,
            },
          ]

          const esdm = [
            {
              LABOR: 'A',
              LBTXT: 'HEAVY EQUIPMENT',
            },
            {
              LABOR: 'B',
              LBTXT: 'LAND TRANSPORT EQUIPMENT',
            },
            {
              LABOR: 'C',
              LBTXT: 'WATER TRANSPORT EQUIPMENT',
            },
            {
              LABOR: 'D',
              LBTXT: 'AIR TRANSPORT EQUIPMENT',
            },
            {
              LABOR: 'E',
              LBTXT: 'COMMUNICATION',
            },
            {
              LABOR: 'F',
              LBTXT: 'LAND SURVEY & RECONNAISSANCE',
            },
            {
              LABOR: 'G',
              LBTXT: 'DRILLING/MINING EQUIPMENT',
            },
            {
              LABOR: 'H',
              LBTXT: 'SAMPLING & LABORATORY',
            },
            {
              LABOR: 'I',
              LBTXT: 'REPAIR AND MAINTENANCE PLANT',
            },
            {
              LABOR: 'J',
              LBTXT: 'BUILDING MATERIALS',
            },
            {
              LABOR: 'K',
              LBTXT: 'UTILITIES, FURNITURE & APPLIAN',
            },
            {
              LABOR: 'L',
              LBTXT: 'CONSUMABLE FUEL, OIL AND GAS',
            },
            {
              LABOR: 'M',
              LBTXT: 'CONSUMABLE FOODSTUFF',
            },
            {
              LABOR: 'N',
              LBTXT: 'CONSUMABLE MISCELLANEOUS',
            },
            {
              LABOR: 'O',
              LBTXT: 'MEDICAL, HEALTH AND SAFETY',
            },
            {
              LABOR: 'P',
              LBTXT: 'RECREATIONAL FACILITIES',
            },
            {
              LABOR: 'Q',
              LBTXT: 'POWER GENERATION',
            },
            {
              LABOR: 'R',
              LBTXT: 'PROCESSING PLANT',
            },
            {
              LABOR: 'S',
              LBTXT: 'SCHOOL & TRAINING',
            },
            {
              LABOR: 'T',
              LBTXT: 'ENVIRONMENTAL',
            },
          ]

          if (total_price['']) {
            esdm.push({
              LABOR: '',
              LBTXT: 'NO CATEGORIES',
            })
          }
          if (total_price['U']) {
            esdm.push({
              LABOR: 'U',
              LBTXT: 'CATEGORIES U',
            })
          }
          if (total_price['V']) {
            esdm.push({
              LABOR: 'V',
              LBTXT: 'CATEGORIES V',
            })
          }
          if (total_price['W']) {
            esdm.push({
              LABOR: 'W',
              LBTXT: 'CATEGORIES W',
            })
          }
          if (total_price['X']) {
            esdm.push({
              LABOR: 'X',
              LBTXT: 'CATEGORIES X',
            })
          }
          if (total_price['Y']) {
            esdm.push({
              LABOR: 'Y',
              LBTXT: 'CATEGORIES Y',
            })
          }
          if (total_price['Z']) {
            esdm.push({
              LABOR: 'Z',
              LBTXT: 'CATEGORIES Z',
            })
          }

          for (let i in esdm) {
            reportData.push({
              categories: esdm[i]['LABOR'],
              cat_desc: esdm[i]['LBTXT'],
              rencana_dom: '-',
              rencana_imp: '-',
              rencana_tkdn: '-',
              realisasi_dom: total_price[esdm[i]['LABOR']]
                ? this.curencyDelimiter(total_price[esdm[i]['LABOR']]['dom'])
                : '-',
              realisasi_imp: total_price[esdm[i]['LABOR']]
                ? this.curencyDelimiter(total_price[esdm[i]['LABOR']]['imp'])
                : '-',
              // realisasi_imp: '',
              realisasi_tkdn: total_belanja[esdm[i]['LABOR']]
                ? this.curencyDelimiter(total_belanja[esdm[i]['LABOR']])
                : '-',
            })
          }

          let totalPriceValues = Object.values(total_price)
          let total_report_all = totalPriceValues.reduce(function (acc, obj) {
            return (
              parseFloat(acc) + parseFloat(obj.all != '-' ? obj.all : 0)
            ).toFixed(2)
          }, 0)

          let total_report_dom = totalPriceValues.reduce(function (acc, obj) {
            return (
              parseFloat(acc) + parseFloat(obj.dom != '-' ? obj.dom : 0)
            ).toFixed(2)
          }, 0)

          let total_report_imp = totalPriceValues.reduce(function (acc, obj) {
            return (
              parseFloat(acc) + parseFloat(obj.imp != '-' ? obj.imp : 0)
            ).toFixed(2)
          }, 0)

          let totalBelanjaValues = Object.values(total_belanja)
          let total_report_tkdn = totalBelanjaValues.reduce(function (acc, obj) {
            return (parseFloat(acc) + parseFloat(obj != '-' ? obj : 0)).toFixed(
              2
            )
          }, 0)

          reportData = [
            ...reportData,
            {
              categories: '',
              cat_desc: '',
              rencana_dom: '',
              rencana_imp: '',
              rencana_tkdn: '',
              realisasi_dom: '',
              realisasi_imp: '',
              realisasi_tkdn: '',
            },
            {
              categories: '',
              cat_desc: 'TOTAL',
              rencana_dom: '-',
              rencana_imp: '-',
              rencana_tkdn: '-',
              realisasi_dom: this.curencyDelimiter(total_report_dom),
              realisasi_imp: this.curencyDelimiter(total_report_imp),
              realisasi_tkdn: this.curencyDelimiter(total_report_tkdn),
            },
            {
              categories: '',
              cat_desc: 'Presentase',
              rencana_dom: '-',
              rencana_imp: '-',
              rencana_tkdn: '-',
              realisasi_dom: `${this.curencyDelimiter(
                (
                  (parseFloat(total_report_dom) /
                    parseFloat(total_report_tkdn)) *
                  100
                ).toFixed(2)
              )} %`,
              realisasi_imp: `${this.curencyDelimiter(
                (
                  (parseFloat(total_report_imp) /
                    parseFloat(total_report_tkdn)) *
                  100
                ).toFixed(2)
              )} %`,
              realisasi_tkdn: `${this.curencyDelimiter(
                (
                  (parseFloat(total_report_tkdn) /
                    parseFloat(total_report_all)) *
                  100
                ).toFixed(2)
              )} %`,
            },
            // {
            //   categories: '',
            //   cat_desc: 'Presentase',
            //   rencana_dom: '-',
            //   rencana_imp: '-',
            //   rencana_tkdn: '-',
            //   realisasi_dom: '-',
            //   realisasi_imp: '-',
            //   realisasi_tkdn: '-',
            // },
            // {
            //   categories: '',
            //   cat_desc: 'TKDN Proyek',
            //   rencana_dom: 'Nilai Proyek',
            //   rencana_imp: 'B.TKDN',
            //   rencana_tkdn: '% TKDN',
            //   realisasi_dom: 'Nilai Proyek',
            //   realisasi_imp: 'B.TKDN',
            //   realisasi_tkdn: '% TKDN',
            // },
            // {
            //   categories: '',
            //   cat_desc: 'TKDN Subkon',
            //   rencana_dom: '-',
            //   rencana_imp: '-',
            //   rencana_tkdn: '-',
            //   realisasi_dom: '-',
            //   realisasi_imp: '-',
            //   realisasi_tkdn: '-',
            // },
            // {
            //   categories: '',
            //   cat_desc: '',
            //   rencana_dom: '',
            //   rencana_imp: '',
            //   rencana_tkdn: '',
            //   realisasi_dom: '',
            //   realisasi_imp: '',
            //   realisasi_tkdn: '',
            // },
            // {
            //   categories: '',
            //   cat_desc: 'Jumlah (Total 1 + Subkon)',
            //   rencana_dom: '-',
            //   rencana_imp: '-',
            //   rencana_tkdn: '-',
            //   realisasi_dom: this.curencyDelimiter(total_report_dom),
            //   realisasi_imp: this.curencyDelimiter(total_report_tkdn),
            //   realisasi_tkdn: `${this.curencyDelimiter(
            //     (
            //       (parseFloat(total_report_tkdn) /
            //         parseFloat(total_report_dom)) *
            //       100
            //     ).toFixed(2)
            //   )} %`,
            // },
            // {
            //   categories: '',
            //   cat_desc: '',
            //   rencana_dom: '',
            //   rencana_imp: '',
            //   rencana_tkdn: '',
            //   realisasi_dom: '',
            //   realisasi_imp: '',
            //   realisasi_tkdn: '',
            // },
            // {
            //   categories: '',
            //   cat_desc: 'Total Capaian realisasi',
            //   rencana_dom: 'Presentase',
            //   rencana_imp: '',
            //   rencana_tkdn: '',
            //   realisasi_dom: '',
            //   realisasi_imp: '',
            //   realisasi_tkdn: '',
            // },
            // {
            //   categories: '',
            //   cat_desc: 'Barang modal dan Proyek',
            //   rencana_dom: '-',
            //   rencana_imp: '',
            //   rencana_tkdn: '',
            //   realisasi_dom: '',
            //   realisasi_imp: '',
            //   realisasi_tkdn: '',
            // },
            // {
            //   categories: '',
            //   cat_desc: 'TKDN',
            //   rencana_dom: '-',
            //   rencana_imp: '',
            //   rencana_tkdn: '',
            //   realisasi_dom: '',
            //   realisasi_imp: '',
            //   realisasi_tkdn: '',
            // },
          ]

          let reportSheet = XLSX.utils.json_to_sheet(reportData)
          const rekapHeader = [
            [
              `${moment(new Date(start)).format('DD MMM, YYYY')} - ${moment(
                new Date(end)
              ).format('DD MMM, YYYY')}`,
              '',
              '',
              '',
              '',
              '',
              '',
              '',
            ],
            ['Kategori', '', 'Rencana', '', '', 'Realisasi', '', ''],
            [
              '',
              '',
              'Domestik (USD)',
              'Import (USD)',
              'Belanja TKDN (USD)',
              'Domestik (USD)',
              'Import (USD)',
              'Belanja TKDN (USD)',
            ],
          ]
          XLSX.utils.book_append_sheet(wb, reportSheet, 'Rekap perkategori')
          XLSX.utils.sheet_add_aoa(reportSheet, rekapHeader, {
            origin: 'A1',
          })
          const mergeReport = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } },
            { s: { r: 1, c: 0 }, e: { r: 2, c: 1 } },
            { s: { r: 1, c: 2 }, e: { r: 1, c: 4 } },
            { s: { r: 1, c: 5 }, e: { r: 1, c: 7 } },
          ]

          reportSheet['!merges'] = mergeReport

          const reportDate = {
            alignment: {
              vertical: 'center',
              horizontal: 'left',
            },
            border: {
              top: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              bottom: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              left: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              right: {
                style: 'thin',
                color: { rgb: '000000' },
              },
            },
          }
          const reportBorder = {
            alignment: {
              vertical: 'center',
              horizontal: 'center',
            },
            font: {
              bold: true,
            },
            border: {
              top: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              bottom: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              left: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              right: {
                style: 'thin',
                color: { rgb: '000000' },
              },
            },
          }
          const reportColor = {
            alignment: {
              vertical: 'center',
              horizontal: 'center',
            },
            font: {
              bold: true,
            },
            fill: { fgColor: { rgb: 'D6E3BC' } },
            border: {
              top: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              bottom: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              left: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              right: {
                style: 'thin',
                color: { rgb: '000000' },
              },
            },
          }
          const reportCategory = {
            border: {
              top: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              bottom: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              left: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              right: {
                style: 'thin',
                color: { rgb: '000000' },
              },
            },
          }
          const reportNumber = {
            alignment: {
              vertical: 'center',
              horizontal: 'right',
            },
            border: {
              top: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              bottom: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              left: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              right: {
                style: 'thin',
                color: { rgb: '000000' },
              },
            },
          }
          const reportCellNull = {
            border: {
              top: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              bottom: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              left: {
                style: 'thin',
                color: { rgb: '000000' },
              },
            },
          }
          const reportTotalCenter = {
            alignment: {
              vertical: 'center',
              horizontal: 'center',
            },
            font: {
              bold: true,
            },
            border: {
              top: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              bottom: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              right: {
                style: 'thin',
                color: { rgb: '000000' },
              },
            },
          }
          const reportTotalCenterNumber = {
            alignment: {
              vertical: 'center',
              horizontal: 'center',
            },
            font: {
              bold: true,
            },
            border: {
              top: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              bottom: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              left: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              right: {
                style: 'thin',
                color: { rgb: '000000' },
              },
            },
          }
          const reportTotalRight = {
            alignment: {
              vertical: 'center',
              horizontal: 'right',
            },
            font: {
              bold: true,
            },
            border: {
              top: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              bottom: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              left: {
                style: 'thin',
                color: { rgb: '000000' },
              },
              right: {
                style: 'thin',
                color: { rgb: '000000' },
              },
            },
          }

          let reportAlpha = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']
          for (let i in reportData) {
            let a = Number(i) + 3
            let defaultList = esdm.length + 5
            let nonDefaultCol = esdm.length + 11
            let freeCol = esdm.length + 12
            let emptCol = esdm.length + 7

            for (let j in reportAlpha) {
              if (a >= defaultList && a <= nonDefaultCol) {
                if (a == emptCol) {
                  if (reportAlpha[j] == 'A') {
                    if (reportSheet[`${reportAlpha[j]}${a}`]) {
                      reportSheet[`${reportAlpha[j]}${a}`].s = reportCellNull
                    }
                  } else if (reportAlpha[j] == 'B') {
                    if (reportSheet[`${reportAlpha[j]}${a}`]) {
                      reportSheet[`${reportAlpha[j]}${a}`].s = reportTotalCenter
                    }
                  } else {
                    if (reportSheet[`${reportAlpha[j]}${a}`]) {
                      reportSheet[
                        `${reportAlpha[j]}${a}`
                      ].s = reportTotalCenterNumber
                    }
                  }
                } else {
                  if (reportAlpha[j] == 'A') {
                    if (reportSheet[`${reportAlpha[j]}${a}`]) {
                      reportSheet[`${reportAlpha[j]}${a}`].s = reportCellNull
                    }
                  } else if (reportAlpha[j] == 'B') {
                    if (reportSheet[`${reportAlpha[j]}${a}`]) {
                      reportSheet[`${reportAlpha[j]}${a}`].s = reportTotalCenter
                    }
                  } else {
                    if (reportSheet[`${reportAlpha[j]}${a}`]) {
                      reportSheet[`${reportAlpha[j]}${a}`].s = reportTotalRight
                    }
                  }
                }
              } else if (a >= freeCol) {
                //do nothing
              } else {
                if (reportAlpha[j] == 'A' || reportAlpha[j] == 'B') {
                  if (reportSheet[`${reportAlpha[j]}${a}`]) {
                    reportSheet[`${reportAlpha[j]}${a}`].s = reportCategory
                  }
                } else {
                  if (reportSheet[`${reportAlpha[j]}${a}`]) {
                    reportSheet[`${reportAlpha[j]}${a}`].s = reportNumber
                  }
                }
              }

              if (a == freeCol + 1) {
                reportSheet[`B${a}`].s = reportTotalCenterNumber

                reportSheet[`C${a}`].s = reportTotalCenterNumber
              }

              if (a == freeCol + 2) {
                reportSheet[`B${a}`].s = reportTotalCenterNumber

                reportSheet[`C${a}`].s = reportTotalCenterNumber
              }

              if (a == freeCol + 3) {
                reportSheet[`B${a}`].s = reportTotalCenterNumber

                reportSheet[`C${a}`].s = reportTotalCenterNumber
              }
            }
          }

          reportSheet['A1'].s = reportDate
          reportSheet['A2'].s = reportBorder
          reportSheet['B1'].s = reportBorder
          reportSheet['B2'].s = reportBorder

          reportSheet['C1'].s = reportColor
          reportSheet['C2'].s = reportColor
          reportSheet['D2'].s = reportColor
          reportSheet['E2'].s = reportColor

          reportSheet['F1'].s = reportColor
          reportSheet['F2'].s = reportColor
          reportSheet['G2'].s = reportColor
          reportSheet['H1'].s = reportColor
          reportSheet['H2'].s = reportColor

          // reportSheet['B33'].s = reportTotalCenterNumber
          // reportSheet['B34'].s = reportTotalCenterNumber
          // reportSheet['B35'].s = reportTotalCenterNumber

          // reportSheet['C33'].s = reportTotalCenterNumber
          // reportSheet['C34'].s = reportTotalCenterNumber
          // reportSheet['C35'].s = reportTotalCenterNumber

          let rsCols = [
            { wch: 5 },
            { wch: 30 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
          ]

          reportSheet['!cols'] = rsCols

          XLSX.writeFile(wb, 'REPORT-TKDN.xlsx') // name of the file is 'book.xlsx'
        } else {
          alert('Data PO tidak di temukan')
        }
      } catch (error) {
        // do nothing
      }
    },
  },
}
</script>
<style scoped>
.doughnat-container {
  width: 33%;
  height: 100%;
  position: relative;
}

.chart-text-center {
  position: absolute;
  top: 53%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 8px;
}
</style>
